var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M8.333 13.833 10 15.5l5.833-5.833m6.039.954-1.42 6.628a5 5 0 0 1-1.545 2.669l-3.783 3.405a5 5 0 0 1-6.69 0L4.65 19.918a5 5 0 0 1-1.544-2.67l-1.42-6.627a5 5 0 0 1 2.268-5.306l5.204-3.202a5 5 0 0 1 5.241 0l5.204 3.202a5 5 0 0 1 2.269 5.306"
  })));
};
export default SvgSecurity;